import {
  TroubleshootAlbumFnReq,
  TroubleshootAlbumFnRes,
  TroubleshootFolderResult,
} from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export class TroubleshootAlbumInteractor {
  private readonly TroubleshootAlbumFn = httpsCallable<
    TroubleshootAlbumFnReq,
    TroubleshootAlbumFnRes
  >(this.functions, 'troubleshootAlbum');

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
  ) {}

  public async execute(id: string): Promise<TroubleshootFolderResult> {
    const res = await this.TroubleshootAlbumFn({
      auth: await this.getAuthDto.execute(),
      id,
    });

    return res.data;
  }
}
